import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import SwitchButton from 'components/Common/SwitchButton'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  toggled: boolean
  onToggle: () => void
  label?: string
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${rem(24)};
`

const DEFAULT_COPY = 'Booked'

const ConfirmedBooking = ({
  toggled,
  onToggle,
  label = DEFAULT_COPY,
}: Props) => (
  <Container>
    <BodyText variant="medium" weight="semi-bold">
      {label}
    </BodyText>
    <SwitchButton toggled={toggled} onToggle={onToggle} />
  </Container>
)

export default React.memo(ConfirmedBooking)
